import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.7998 8.625L22 9.25L16.5498 13.9746L18.1748 21L12 17.2754L5.8252 21L7.4502 13.9746L2 9.25L9.2002 8.625L12 2L14.7998 8.625Z" })
});
export default SvgStarFilled;
